import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Description`}</h3>
    <p>{`There are three levels of org users:`}</p>
    <ol>
      <li parentName="ol">{`Super admin, controls billing & adding people to the org.`}</li>
      <li parentName="ol">{`Team admin, manages team membership & package access.`}</li>
      <li parentName="ol">{`Developer, works on packages they are given access to.  `}</li>
    </ol>
    <p>{`The super admin is the only person who can add users to the org because it impacts the monthly bill. The super admin will use the website to manage membership. Every org has a `}<inlineCode parentName="p">{`developers`}</inlineCode>{` team that all users are automatically added to.`}</p>
    <p>{`The team admin is the person who manages team creation, team membership, and package access for teams. The team admin grants package access to teams, not individuals.`}</p>
    <p>{`The developer will be able to access packages based on the teams they are on. Access is either read-write or read-only.`}</p>
    <p>{`There are two main commands:`}</p>
    <ol>
      <li parentName="ol"><inlineCode parentName="li">{`npm team`}</inlineCode>{` see `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-team"
        }}>{`npm team`}</a>{` for more details`}</li>
      <li parentName="ol"><inlineCode parentName="li">{`npm access`}</inlineCode>{` see `}<a parentName="li" {...{
          "href": "/cli/v8/commands/npm-access"
        }}>{`npm access`}</a>{` for more details`}</li>
    </ol>
    <h3>{`Team Admins create teams`}</h3>
    <ul>
      <li parentName="ul">{`Check who you’ve added to your org:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm team ls <org>:developers
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Each org is automatically given a `}<inlineCode parentName="p">{`developers`}</inlineCode>{` team, so you can see the whole list of team members in your org. This team automatically gets read-write access to all packages, but you can change that with the `}<inlineCode parentName="p">{`access`}</inlineCode>{` command.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Create a new team:`}</p>
      </li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm team create <org:team>
`}</code></pre>
    <ul>
      <li parentName="ul">{`Add members to that team:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm team add <org:team> <user>
`}</code></pre>
    <h3>{`Publish a package and adjust package access`}</h3>
    <ul>
      <li parentName="ul">{`In package directory, run`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm init --scope=<org>
`}</code></pre>
    <p>{`to scope it for your org & publish as usual`}</p>
    <ul>
      <li parentName="ul">{`Grant access:  `}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access grant <read-only|read-write> <org:team> [<package>]
`}</code></pre>
    <ul>
      <li parentName="ul">{`Revoke access:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access revoke <org:team> [<package>]
`}</code></pre>
    <h3>{`Monitor your package access`}</h3>
    <ul>
      <li parentName="ul">{`See what org packages a team member can access:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access ls-packages <org> <user>
`}</code></pre>
    <ul>
      <li parentName="ul">{`See packages available to a specific team:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access ls-packages <org:team>
`}</code></pre>
    <ul>
      <li parentName="ul">{`Check which teams are collaborating on a package:`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm access ls-collaborators <pkg>
`}</code></pre>
    <h3>{`See also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-team"
        }}>{`npm team`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-access"
        }}>{`npm access`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/scope"
        }}>{`npm scope`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      